export default __webpack_public_path__ + "static/media/skinke-zoomed.7555350d.svg";